/**
 * The waitlist's select options — features/LANDING.md.
 *
 * Apart from `schemas/waitlist.ts` so the landing page can render the form
 * without importing Zod. The schema is needed only when someone submits, and
 * the form loads it then; the options are needed on first paint.
 */
export const BUSINESS_TYPES = [
    'cafe',
    'restaurant',
    'supermarket',
    'bakery',
    'salon',
    'barbershop',
    'carwash',
    'gym',
    'other',
];
export const LOCATION_COUNTS = ['1', '2-3', '4-10', '10+'];
//# sourceMappingURL=waitlist-options.js.map